const createImage = url =>
  new Promise((resolve, reject) => {
    const image = new Image()
    image.addEventListener('load', () => resolve(image))
    image.addEventListener('error', error => reject(error))
    image.setAttribute('crossOrigin', 'anonymous') // needed to avoid cross-origin issues on CodeSandbox
    image.src = url
  })

function getRadianAngle(degreeValue) {
  return (degreeValue * Math.PI) / 180
}

/**
 * This function was adapted from the one in the ReadMe of https://github.com/DominicTobias/react-image-crop
 * @param {File} image - Image File url
 * @param {Object} pixelCrop - pixelCrop Object provided by react-easy-crop
 * @param {number} rotation - optional rotation parameter
 */
export default function getCroppedImg(imgObj, pixelCrop, obj, rotation = 0, module='clientAsso') { 
  var fileName = imgObj.name
  var _URL = window.URL || window.webkitURL;
  var objectUrl = _URL.createObjectURL(imgObj);
  const image = new Image()
  var tmpHeight = 0;
  var tmpWidth = 0;
  image.addEventListener("load", function () {
            tmpWidth = this.width;
            tmpHeight = this.height;
            _URL.revokeObjectURL(objectUrl);
              const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        // const maxSize = Math.max(image.width, image.height)
        const maxSize = Math.max(tmpWidth,tmpHeight)
        const safeArea = 2 * ((maxSize / 2) * Math.sqrt(2))

        // set each dimensions to double largest dimension to allow for a safe area for the
        // image to rotate in without being clipped by canvas context
        canvas.width = safeArea
        canvas.height = safeArea
        // translate canvas context to a central location on image to allow rotating around the center.
        ctx.translate(safeArea / 2, safeArea / 2)
        ctx.rotate(getRadianAngle(rotation))
        ctx.translate(-safeArea / 2, -safeArea / 2)

        // draw rotated image and store data.
        ctx.drawImage(
          image,
          safeArea / 2 - tmpWidth * 0.5,
          safeArea / 2 - tmpHeight * 0.5
        )

        const data = ctx.getImageData(0, 0, safeArea, safeArea)

        // set canvas width to final desired crop size - this will clear existing context
        canvas.width = pixelCrop.width
        canvas.height = pixelCrop.height

        // paste generated rotate image with correct offsets for x,y crop values.
        ctx.putImageData(
          data,
          Math.round(0 - safeArea / 2 + tmpWidth * 0.5 - pixelCrop.x),
          Math.round(0 - safeArea / 2 + tmpHeight * 0.5 - pixelCrop.y)
        )

        let activeUserData = null;
        let contactData = null;
        let affiliateData = null;
        let clientData = null;
        let companyInfo = null;
        let crewData = null;
        let basicInfo = null;
        if(module == 'affiliateAsso'){
          activeUserData = obj.state.activeUserData;
        }else if(module == 'affProfile'){
          affiliateData = obj.state.affiliateData;     
          companyInfo = obj.state.affiliateData.companyInfo;
        
        }else if(module == 'superProfile'){
          companyInfo = obj.state.companyInfo;
        
        }else if(module == 'clientLogo' || module == 'clientSign'){
          clientData = obj.state.clientData;     
          companyInfo = obj.state.clientData.companyInfo
        }else if(module == 'crewProfile'){
          crewData = obj.state.crewData;     
          basicInfo = obj.state.crewData.basicInfo
        }else{
          contactData = obj.state.contactData;
        }
        canvas.toBlob(function(blob){
            var imageUrl = URL.createObjectURL(blob);
            var file = new File([blob], fileName, {lastModified: new Date()});
            if(module == 'affiliateAsso'){
              activeUserData['profile_picture'] = file;
              activeUserData['profile_pic_url'] = imageUrl;
              obj.setState({imgUrl:imageUrl,activeUserData:activeUserData});
              // obj.refs.modalCropper.handleModelClose();
              obj.modalCropper.current.handleModelClose();
            }else if(module == 'affProfile'){
              companyInfo['logo'] = file
              obj.setState({imgUrl:imageUrl,affiliateData});
              // obj.refs.logoModalCropper.handleModelClose();
              obj.logoModalCropper.current.handleModelClose();
            }else if(module == 'superProfile'){
              companyInfo['logo'] = file;
              obj.setState({imgUrl:imageUrl,companyInfo});
              //obj.refs.logoModalCropper.handleModelClose();
              obj.logoModalCropper.current.handleModelClose();
            }else if(module == 'clientLogo'){ 
              companyInfo['logo']=file;
              obj.setState({logoImgUrl:imageUrl,imgUrl:imageUrl,clientData:clientData});
              //obj.refs.logoModalCropper.handleModelClose();
              obj.logoModalCropper.current.handleModelClose();
            }else if(module == 'clientSign'){
              companyInfo['signature']=file;
              obj.setState({signImgUrl:imageUrl,signatureUrl:imageUrl,clientData:clientData}); 
              if(obj.refs.signModalCropper) {
                obj.refs.signModalCropper.handleModelClose();
              }
              else {
                obj.signModalCropper.current.handleModelClose();
              }
            }else if(module == 'crewProfile'){
              basicInfo['logo']=file;
              obj.setState({imgUrl:imageUrl,crewData:crewData});
              // obj.logoModalCropper.handleModelClose();
              obj.logoModalCropper.current.handleModelClose();
            }else{
              contactData['logo']=file;
              obj.setState({imgUrl:imageUrl,contactData:contactData}); 
              obj.modalCropper.current.handleModelClose();
              //obj.refs.modalCropper.handleModelClose();
            }
            
          },'image/png');

  });

  image.src = objectUrl;
  
  // while(tmpWidth==0){
  //   console.log(tmpWidth);
  // }


  // As Base64 string
  // return canvas.toDataURL('image/jpeg');

  // return canvas
}
